import { Image, Typography } from "antd"
import React, { useState } from "react"

const { Link } = Typography

export default function ShowImageWithLink({ link }) {
  const [visible, setVisible] = useState(false)

  return (
    <div>
      <Link type="primary" onClick={() => setVisible(true)}>
        show technical
      </Link>
      <Image
        width={0}
        style={{
          display: "none",
        }}
        src={link}
        preview={{
          visible,
          src: link,
          onVisibleChange: (value) => {
            setVisible(value)
          },
        }}
      />
    </div>
  )
}
